// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminDataTable .btn.btn-link {
    height: auto;
}
.adminDataTable.table>tbody>tr>td {
    padding: 10px 15px;
}
.example-handle {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #ccc;
  cursor: move;
  width: 24px;
  height: 24px;
}
.mat-expansion-panel-header.mat-expansion-toggle-indicator-before {
  position: relative;
}
.mat-expansion-panel-header-description {
  flex-direction: column;
}
.ansLabel {
  display: inline-block;
  margin-right: 50px;
}
.bigLabel {
  font-size: 15px;
  color: #000000;
}
.addStratification {
  position: relative;
  margin-top: -75px;
}
.mat-expansion-panel-header, .mat-expansion-panel-body {
  font-family: 'Noto Sans',Arial, sans-serif;
}
.mat-expansion-panel-header:not([aria-disabled=true]) {
  background-color: #f8f8f8;
  border-top: 1px solid #dddddd;
  font-size: 13px;
  height: auto;
  padding: 1rem 5rem 1rem 2rem;
}
.mat-expansion-panel-spacing {
  margin: 0;
  border-radius: 0;
}
.removeQues {
  padding: 0;
  font-size: 26px;
  line-height: 55px;
  position: absolute;
  right: 10px;
  z-index: 2;
}
.ansTextBox {
  padding-right: 38px;
}
.exportExcelBtn {
  position: absolute;
  top: -75px;
  right: 180px;
  z-index: 2;
  height: 38px;
  background-color: #ffffff;
}
  .exportExcelBtn:hover {
    background-color: #007bff;
    border: 1px solid #007bff;
  }
.ansWrap {
  padding: 0 5px;
  display: inline-block
}
.removeLink {
  height: auto;
}
.spinner-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fa-spinner {
  font-size: 4em;
}

.spinner-container p {
  margin-top: 10px;
  font-size: 1.2em;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/pre-screening-questions/admin_prescreener_list.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;EACE;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;AACF;EACE,cAAc;EACd;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".adminDataTable .btn.btn-link {\r\n    height: auto;\r\n}\r\n.adminDataTable.table>tbody>tr>td {\r\n    padding: 10px 15px;\r\n}\r\n.example-handle {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  color: #ccc;\r\n  cursor: move;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.mat-expansion-panel-header.mat-expansion-toggle-indicator-before {\r\n  position: relative;\r\n}\r\n.mat-expansion-panel-header-description {\r\n  flex-direction: column;\r\n}\r\n.ansLabel {\r\n  display: inline-block;\r\n  margin-right: 50px;\r\n}\r\n.bigLabel {\r\n  font-size: 15px;\r\n  color: #000000;\r\n}\r\n.addStratification {\r\n  position: relative;\r\n  margin-top: -75px;\r\n}\r\n.mat-expansion-panel-header, .mat-expansion-panel-body {\r\n  font-family: 'Noto Sans',Arial, sans-serif;\r\n}\r\n.mat-expansion-panel-header:not([aria-disabled=true]) {\r\n  background-color: #f8f8f8;\r\n  border-top: 1px solid #dddddd;\r\n  font-size: 13px;\r\n  height: auto;\r\n  padding: 1rem 5rem 1rem 2rem;\r\n}\r\n.mat-expansion-panel-spacing {\r\n  margin: 0;\r\n  border-radius: 0;\r\n}\r\n.removeQues {\r\n  padding: 0;\r\n  font-size: 26px;\r\n  line-height: 55px;\r\n  position: absolute;\r\n  right: 10px;\r\n  z-index: 2;\r\n}\r\n.ansTextBox {\r\n  padding-right: 38px;\r\n}\r\n.exportExcelBtn {\r\n  position: absolute;\r\n  top: -75px;\r\n  right: 180px;\r\n  z-index: 2;\r\n  height: 38px;\r\n  background-color: #ffffff;\r\n}\r\n  .exportExcelBtn:hover {\r\n    background-color: #007bff;\r\n    border: 1px solid #007bff;\r\n  }\r\n.ansWrap {\r\n  padding: 0 5px;\r\n  display: inline-block\r\n}\r\n.removeLink {\r\n  height: auto;\r\n}\r\n.spinner-container {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.fa-spinner {\r\n  font-size: 4em;\r\n}\r\n\r\n.spinner-container p {\r\n  margin-top: 10px;\r\n  font-size: 1.2em;\r\n  color: #000;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
